if (!customElements.get('mobile-menu-panels')) {
  class MobileMenuPanels extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.mobile-menu-panels-container');
      this.forwardLinks = this.querySelectorAll('a[data-target-panel]');
      this.backButtons = this.querySelectorAll('.panel-back-button');
      this.currentLevel = 1;
    }

    connectedCallback() {
      this.forwardLinks.forEach(link => {
        link.addEventListener('click', this.goToPanel.bind(this));
      });
      this.backButtons.forEach(button => {
        button.addEventListener('click', this.goBack.bind(this));
      });
    }

    goToPanel(event) {
      const targetPanelId = event.currentTarget.dataset.targetPanel;

      if (!targetPanelId) {
        // If no target panel specified, let the link work as normal
        return;
      }

      // Always prevent default navigation when panel switching
      event.preventDefault();

      const targetPanel = this.querySelector(`[data-panel-id="${targetPanelId}"]`);

      if (!targetPanel) {
        console.warn(`Panel not found: ${targetPanelId}`);
        return;
      }

      // Deactivate all panels first
      this.querySelectorAll('.mobile-menu-panel').forEach(panel => {
        panel.classList.remove('is-active');
      });

      // Activate target panel
      targetPanel.classList.add('is-active');

      const targetLevel = parseInt(targetPanel.dataset.level, 10);
      this.currentLevel = targetLevel;
      this.updateContainerPosition();
    }

    goBack(event) {
      const currentPanel = event.currentTarget.closest('.mobile-menu-panel');
      const currentLevel = parseInt(currentPanel.dataset.level, 10);
      this.currentLevel = currentLevel - 1;
      this.updateContainerPosition();
    }
    
    updateContainerPosition() {
      const newPosition = -100 * (this.currentLevel - 1);
      this.container.style.transform = `translateX(${newPosition}%)`;
    }
  }
  customElements.define('mobile-menu-panels', MobileMenuPanels);
}